import React from 'react';
import { RETAILERS } from '../constants';
import { 
  Store, 
  Search, 
  Filter, 
  Download, 
  MapPin, 
  Phone, 
  ChevronRight,
  MoreVertical,
  CheckCircle2,
  Clock
} from 'lucide-react';

export const RetailerDirectory: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-black text-text">Retailer Directory</h1>
          <p className="text-text2">Manage all your retailers and their business profiles</p>
        </div>
        <div className="flex gap-3">
          <button className="btn-secondary flex items-center gap-2">
            <Download size={16} />
            Export
          </button>
          <button className="btn-primary flex items-center gap-2">
            <Store size={16} />
            Add Retailer
          </button>
        </div>
      </div>

      <div className="card overflow-hidden">
        <div className="p-4 border-b border-border flex flex-wrap gap-4 items-center justify-between">
          <div className="flex gap-3 flex-1 max-w-md">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-text3" size={16} />
              <input 
                type="text" 
                placeholder="Search by name, area or ID..." 
                className="w-full h-10 pl-10 pr-4 bg-gray-50 border border-border rounded-lg text-sm focus:border-primary outline-hidden"
              />
            </div>
            <button className="p-2 border border-border rounded-lg text-text3 hover:bg-gray-50">
              <Filter size={18} />
            </button>
          </div>
          <div className="flex gap-2">
            <span className="px-3 py-1 bg-indigo-50 text-primary rounded-full text-[10px] font-bold uppercase">All Retailers</span>
            <span className="px-3 py-1 text-text3 rounded-full text-[10px] font-bold uppercase hover:bg-gray-50 cursor-pointer">Active</span>
            <span className="px-3 py-1 text-text3 rounded-full text-[10px] font-bold uppercase hover:bg-gray-50 cursor-pointer">Pending</span>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead className="bg-gray-50 text-[10px] font-black text-text3 uppercase tracking-widest">
              <tr>
                <th className="px-6 py-3">Retailer Name</th>
                <th className="px-6 py-3">Area / Channel</th>
                <th className="px-6 py-3">Contact</th>
                <th className="px-6 py-3">MTD Sales</th>
                <th className="px-6 py-3">Status</th>
                <th className="px-6 py-3 text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {RETAILERS.map((retailer) => (
                <tr key={retailer.id} className="hover:bg-gray-50 transition-colors cursor-pointer group">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center text-primary font-bold text-xs">
                        {retailer.name.charAt(0)}
                      </div>
                      <div className="flex flex-col">
                        <span className="font-bold text-text">{retailer.name}</span>
                        <span className="text-[10px] text-text3 font-mono">#{retailer.id}</span>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex flex-col">
                      <span className="text-xs font-medium text-text2 flex items-center gap-1">
                        <MapPin size={12} className="text-text3" /> {retailer.area}
                      </span>
                      <span className="text-[10px] font-bold text-text3 uppercase mt-1">{retailer.channel}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2 text-text2">
                      <Phone size={14} className="text-text3" />
                      <span className="text-xs font-medium">+91 98765 43210</span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span className="font-bold text-text">₹{retailer.valueMTD.toLocaleString()}</span>
                  </td>
                  <td className="px-6 py-4">
                    <span className="px-2 py-0.5 bg-emerald-100 text-emerald-700 rounded-full text-[10px] font-bold uppercase">Active</span>
                  </td>
                  <td className="px-6 py-4 text-right">
                    <button className="p-2 text-text3 hover:text-primary transition-colors">
                      <ChevronRight size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
